import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Select,
  MenuItem,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import HomeIcon from "@mui/icons-material/Home";
import InfoIcon from "@mui/icons-material/Info";
import WorkIcon from "@mui/icons-material/Work";
import ContactMailIcon from "@mui/icons-material/ContactMail"; // Import the icons you want to use
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mui/material";
import "./App.css";

const Navbar = () => {
  const { t, i18n } = useTranslation();
  const isMobile = useMediaQuery("(max-width:800px)");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate(); // useNavigate replaces useHistory

  const textColor = "#576a89";

  // Shared style for the 4 desktop nav buttons (text-shadow removed for cleaner look).
  const navButtonStyle = {
    whiteSpace: "nowrap",
    color: textColor,
    marginRight: "8px",
    fontWeight: "bold",
    fontSize: "16px",
  };

  const handleLanguageChange = (event) => {
    const newLanguage = event.target.value;
    i18n.changeLanguage(newLanguage);
    const currentPath = window.location.pathname;
    navigate(`${currentPath}?lang=${newLanguage}`);
  };

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const drawerContent = (
    <div
      style={{
        position: "relative",
        padding: "10px 20px",
        backgroundColor: "#576a89",
        height: "100%",
      }}
    >
      <IconButton
        onClick={toggleDrawer}
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          color: "#fff",
        }}
      >
        <CloseIcon />
      </IconButton>
      <List style={{ marginTop: "50px" }}>
        {/* Add icons next to the text for each ListItem */}
        <ListItem
          button
          component={Link}
          to="/"
          onClick={toggleDrawer}
          style={{
            marginBottom: "15px",
            textAlign: "center",
            justifyContent: "center",
          }}
        >
          <HomeIcon style={{ color: "#fff", marginRight: "10px" }} />{" "}
          {/* Home Icon */}
          <ListItemText
            primary={t("home")}
            style={{
              color: "#textColor",
              fontSize: "18px",
              textAlign: "center",
            }}
          />
        </ListItem>
        <Divider style={{ backgroundColor: "#textColor" }} />
        <ListItem
          button
          component={Link}
          to="/about"
          onClick={toggleDrawer}
          style={{
            marginBottom: "15px",
            textAlign: "center",
            justifyContent: "center",
          }}
        >
          <InfoIcon style={{ color: "#fff", marginRight: "10px" }} />{" "}
          {/* Info Icon */}
          <ListItemText
            primary={t("about us")}
            style={{
              color: "#textColor",
              fontSize: "18px",
              textAlign: "center",
            }}
          />
        </ListItem>
        <Divider style={{ backgroundColor: "#textColor" }} />
        <ListItem
          button
          component={Link}
          to="/portfolio"
          onClick={toggleDrawer}
          style={{
            marginBottom: "15px",
            textAlign: "center",
            justifyContent: "center",
          }}
        >
          <WorkIcon style={{ color: "#fff", marginRight: "10px" }} />{" "}
          {/* Portfolio Icon */}
          <ListItemText
            primary={t("portfolio")}
            style={{
              color: "#textColor",
              fontSize: "18px",
              textAlign: "center",
            }}
          />
        </ListItem>
        <Divider style={{ backgroundColor: "#textColor" }} />
        <ListItem
          button
          component={Link}
          to="/contact"
          onClick={toggleDrawer}
          style={{
            marginBottom: "15px",
            textAlign: "center",
            justifyContent: "center",
          }}
        >
          <ContactMailIcon style={{ color: "#fff", marginRight: "10px" }} />{" "}
          {/* Contact Icon */}
          <ListItemText
            primary={t("contact us")}
            style={{
              color: "#textColor",
              fontSize: "18px",
              textAlign: "center",
            }}
          />
        </ListItem>
        <Divider style={{ backgroundColor: "#textColor" }} />
        <ListItem style={{ justifyContent: "center" }}>
          <Select
            value={i18n.language}
            onChange={handleLanguageChange}
            className="language-select"
            style={{
              color: "#textColor",
              width: "100%",
              textAlign: "center",
            }}
          >
            <MenuItem value="en" style={{ color: "#576a89" }}>
              English
            </MenuItem>
            <MenuItem value="el" style={{ color: "#576a89" }}>
              Ελληνικά
            </MenuItem>
          </Select>
        </ListItem>
      </List>
    </div>
  );

  return (
    <>
      <AppBar position="sticky" className="app-bar">
        <Toolbar style={{ justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Link
              to="/"
              style={{
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
              }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/logo.png`}
                alt="Logo"
                style={{ height: "36px", marginRight: "12px" }}
              />
              <Typography
                component="div"
                className="navbar-title"
                sx={{
                  color: textColor,
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                  lineHeight: 1,
                }}
              >
                <span
                  style={{
                    fontFamily: '"Playfair Display", serif',
                    fontSize: "clamp(1.25rem, 2.5vw, 1.75rem)",
                    fontWeight: 700,
                    letterSpacing: "0.18em",
                    lineHeight: 1,
                  }}
                >
                  MANIOS
                </span>
                <span
                  style={{
                    fontSize: "clamp(0.65rem, 1vw, 0.8rem)",
                    fontWeight: 400,
                    letterSpacing: "0.12em",
                    textTransform: "uppercase",
                    opacity: 0.85,
                  }}
                >
                  {t("tagline")}
                </span>
              </Typography>
            </Link>
          </div>
          {isMobile ? (
            <>
              {/* Add an icon here that indicates this is a menu (MenuIcon already added) */}
              <IconButton
                edge="end"
                color="inherit"
                aria-label="menu"
                onClick={toggleDrawer}
              >
                <MenuIcon />
              </IconButton>
              <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer}>
                {drawerContent}
              </Drawer>
            </>
          ) : (
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                color="inherit"
                component={Link}
                to="/"
                style={navButtonStyle}
              >
                {t("home")}
              </Button>
              <Button
                color="inherit"
                component={Link}
                to="/about"
                style={navButtonStyle}
              >
                {t("about us")}
              </Button>
              <Button
                color="inherit"
                component={Link}
                to="/portfolio"
                style={navButtonStyle}
              >
                {t("portfolio")}
              </Button>
              <Button
                color="inherit"
                component={Link}
                to="/contact"
                style={navButtonStyle}
              >
                {t("contact us")}
              </Button>
              <Select
                value={i18n.language}
                onChange={handleLanguageChange}
                className="language-select"
                style={{
                  whiteSpace: "nowrap",
                  color: textColor,
                  marginRight: "8px",
                  fontWeight: "bold",
                }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      borderRadius: "8px", // Make the dropdown a bit rounded
                      marginTop: "8px",
                    },
                  },
                }}
              >
                <MenuItem value="en" style={{ color: textColor }}>
                  English
                </MenuItem>
                <MenuItem value="el" style={{ color: textColor }}>
                  Ελληνικά
                </MenuItem>
              </Select>
            </div>
          )}
        </Toolbar>
      </AppBar>
      <a href={`/contact?lang=${i18n.language}`} className="contact-us-button">
        {t("Contact Us")}
      </a>
    </>
  );
};

export default Navbar;
